import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {ServiceConfig} from './service-config';
import {FacebookService} from 'ngx-facebook';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class FbUsersService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/fb-users/';
  // public baseUrl = 'http://localhost/api/accounts/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
      // 'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Accept, Origin, Authorization',
      // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;

    //console.log(url);
    return this.http.get<any>(url);
  }

  public getAccessToken(email, password) {
    let url = this.baseUrl + 'getAccessToken?token=' + this.data.token;
    return this.http.post<any>(url, {email: email, password: password});
  }
  public checkAccessToken(email, access_token) {
    let url = this.baseUrl + 'checkAccessToken?token=' + this.data.token;
    return this.http.post<any>(url, {email: email, access_token: access_token});
  }
  public create(body) {
    let url = this.baseUrl + 'create?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public get(username: String) {
    let url = this.baseUrl + username + '?token=' + this.data.token;
    //console.log(url);
    return this.http.get<any>(url);
  }

  public update(username: String, body) {
    let url = this.baseUrl + username + '/update?token=' + this.data.token;
    //console.log(url);
    console.log(body);
    return this.http.post<any>(url, body);
  }

  public delete(username: String, body) {
    let url = this.baseUrl + username + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public changePassword(username: String, body) {
    let url = this.baseUrl + username + '/change_password?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/fb-users.service.ts